import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createReportComponentActions } from './actions';
import { ReportComponentActions, ReportComponentState } from './types';

export const useReportComponentStore = create<ReportComponentState & ReportComponentActions>()(
    immer((set, get, store) => ({
        reportComponents: [],
        reportComponentsById: {},
        lastPersistedLayout: {},
        loading: false,
        reportComponentsLoadState: { status: 'idle' },
        selectedReportComponent: null,
        loadingReportComponent: false,
        error: undefined,
        editingComponentId: undefined,
        draftConfigurations: {},
        draftProperties: {},
        componentValidationState: undefined,
        ...createReportComponentActions(set, get, store),
    })),
);
